export default __webpack_public_path__ + "locales/az/Ldap.json?hash=e30fa775a6d2e14a3d075a719de95fa8";